import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "pre-load-image",
  src: "img/icons/icon_fast.svg#svgView(viewBox(0,0,0,0))",
  style: {"width":"0px"}
}, null, -1)
const _hoisted_2 = { class: "px-12 pt-12 pb-6 flex flex-col items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-52 h-52 my-6 items-center text-center",
  src: "/img/logo_fast.svg"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("เข้าสู่ระบบ")
const _hoisted_5 = { class: "text-center p-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 text-sm" }, null, -1)
const _hoisted_7 = { class: "text-gray-300 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonModalWithPreset = _resolveComponent("CommonModalWithPreset")!
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_CommonForm = _resolveComponent("CommonForm")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_PageSinglePanelVertical = _resolveComponent("PageSinglePanelVertical")!

  return (_openBlock(), _createBlock(_component_PageSinglePanelVertical, {
    class: "login",
    style: _normalizeStyle(`background-image: url('/img/background.png');`)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CommonModalWithPreset, {
        ref: "modal",
        type: "login-failed",
        onDone: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.modal.close()))
      }, null, 512),
      _createVNode(_component_Panel, { class: "login-panel" }, {
        float: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, "Version: " + _toDisplayString(_ctx.buildNote), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_CommonForm, {
              class: "w-full",
              form: _ctx.loginFormInput
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CommonInput, {
                  class: "my-6",
                  id: "common-input-email",
                  rules: "required",
                  type: "text",
                  label: "อีเมล",
                  autocomplete: "email",
                  name: "email",
                  modelValue: _ctx.loginFormInput.email,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginFormInput.email) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_CommonInput, {
                  class: "my-6",
                  id: "common-input-password",
                  rules: "required",
                  type: "password",
                  label: "รหัสผ่าน",
                  autocomplete: "password",
                  level: "white",
                  name: "password",
                  modelValue: _ctx.loginFormInput.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginFormInput.password) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_CommonButton, {
                  class: "mt-12",
                  type: "submit",
                  level: "primary",
                  block: "",
                  "can-load": ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["form"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}